import React from "react";
import { FaPlus } from "react-icons/fa";

function CryWCloneHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Crypto Wallet Clone Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Launch clone of popular crypto wallets like Metamask or
                    Trust Wallet with the features and functionality of leading
                    wallet platforms, tailored to your business needs for a
                    seamless and secure user experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CryWCloneHero;
